/*
 * Copyright (c) 2022 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Tuesday, April 26th 2022, 1:03:29 pm
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Grid from "@mui/material/Grid";
import { WorkerAccount } from "lib/schemas";
import { useAPIListTeams } from "teams/services/TeamsAPI";
import React from "react";
import { APIListProgressWrapper } from "ui-widgets";
import { EmptyWorkerTeamsCTA } from "./EmptyWorkerTeamsCTA";

export const WorkerAssignedTeam = ({ workerId }: { workerId: WorkerAccount["id"] }) => {
  const { teams, isMakingAPIRequest, httpResponseStatusCode, isAPIError } = useAPIListTeams({
    makeRequestOnInitialMount: true,
    apiQueryParams: { member: workerId },
  });

  return (
    <APIListProgressWrapper
      items={teams}
      showLoader={isMakingAPIRequest}
      httpResponseStatusCode={httpResponseStatusCode}
      isAPIError={isAPIError}
      noDataMessage={<EmptyWorkerTeamsCTA />}
    >
      <Grid container spacing={2}>
        <Grid item xs={6}>
          Team
        </Grid>
        <Grid item xs={6}>
          Number of members
        </Grid>
        {teams.map((team) => (
          <React.Fragment key={`${team.id}`}>
            <Grid item xs={6}>
              {team.team_name}
            </Grid>
            <Grid item xs={6}>
              {team.members.length}
            </Grid>
          </React.Fragment>
        ))}
      </Grid>
    </APIListProgressWrapper>
  );
};
